module.exports = __webpack_public_path__ + "img/mn.c731ac75.png";